import { parsePart } from '../../convert/xmlToSheet';
import { Measure } from './Measure';
import { XMLElementParser } from './XMLElementParser';
export class Part extends XMLElementParser {
    scorePart;
    constructor(node, scoreParts) {
        super(node);
        const scorePart = scoreParts?.find(sp => sp.id === this.id);
        if (scorePart == null) {
            throw new Error(`ScorePart with id ${this.id} not found`);
        }
        this.scorePart = scorePart;
    }
    get instruments() {
        return this.scorePart.instruments;
    }
    get id() {
        return this.node.attributes?.id;
    }
    get sheets() {
        return parsePart(this);
    }
    get measures() {
        const measureNodes = this.node.elements?.filter(e => e.name === 'measure') ?? [];
        return measureNodes.map(node => new Measure(node));
    }
}
//# sourceMappingURL=Part.js.map